import React from 'react';
import './ErrorMessage.css';

const ErrorMessage = ({ error, onClose }) => {
  if (!error) return null;

  return (
    <div className="error-message-overlay">
      <div className="error-message-container">
        <div className="error-message-header">
          <h3>오류</h3>
          {onClose && (
            <button className="error-close-btn" onClick={onClose}>
              ✕
            </button>
          )}
        </div>
        <div className="error-message-content">
          <p className="error-main-message">{error.message}</p>
        </div>
        {onClose && (
          <div className="error-message-footer">
            <button className="error-confirm-btn" onClick={onClose}>
              확인
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;

